import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("thuraya_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const DEFAULT_WA_MESSAGE =
    "السلام عليكم، أود الاستفسار عن إطارات لسيارتي من شركة إطار الثريا لخدمات السيارات";

export const fullUrl = (u) =>
    u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
